import { render, staticRenderFns } from "./AppFormDetail.vue?vue&type=template&id=3a697706"
import script from "@/controllers/custom/application_form/app-form-detail.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/application_form/app-form-detail.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports